import { Button } from "@mui/material";

const BusinessTable = ({biz, idx, getAudit}) => {

  return (
    <tr key={idx}>
      <td>{biz.name}</td>
      <td>{biz.phone}</td>
      <td>
        <a href={biz.website} target="_blank" rel="noreferrer">
          Visit Website
        </a>
      </td>
      <td>{biz.address}</td>
      <td><Button variant="contained" onClick={() => getAudit(biz)}>Audit</Button></td>
    </tr>
  );
};

export default BusinessTable;
